import api from './api/axiosConfig'; 
import API_ENDPOINTS from './api/endpoints';
/**
 * Handles user login.
 */
export const login = async (email, password,role) => {
    try {
        const response = await api.post(API_ENDPOINTS.AUTH.LOGIN, { email, password,role });



        const { body } = response.data;

        if (body==null) {
            return null;
        }
        if (body.cpaLoginSessionGuid) {
            localStorage.setItem('access_token', body.cpaLoginSessionGuid);
        }

        return body; 
    } catch (error) {
        console.error('Login service error:', error);
        throw error;
    }
};

/**
 * Handles user logout.
 */
export const logout = async (navigate, setLoading, setError, setIsProfileDropdownOpen) => {
    
    setLoading(true);
    setError(null); 

    try {
        const token = localStorage.getItem('access_token');

        if (!token) {
            console.warn('No access token found. Redirecting to login.');
            navigate('/');
            return;
        }

        await api.post(API_ENDPOINTS.AUTH.LOGOUT); 

        console.log('Logout successful:');
        localStorage.removeItem('access_token');
        // localStorage.removeItem('user'); // Uncomment if you store user data
        setIsProfileDropdownOpen(false); // Close dropdown on successful logout
        navigate('/'); // Redirect to login page
    } catch (err) {
        // err.message will be the error response from the interceptor (error.response.data)
        console.error('Logout failed or network error:', err);
        setError(err.message || 'Logout failed. Please try again.');

        if (localStorage.getItem('access_token') === null) {
            navigate('/'); // Ensure redirection if token is removed by interceptor or other means
        }
    } finally {
        setLoading(false);
    }
};


export const checkAuth = async () => {
    const sessionGuid = localStorage.getItem('access_token'); // Get token from localStorage

    // 1. If no token exists at all, we're definitely not authenticated.
    if (!sessionGuid) {
        return null;
    }

    try {

        const response = await api.post(
            '/cpa-session-validation'
        );

        if (response.data.statuscode == 202) {
            localStorage.setItem('user', JSON.stringify(response.data));

        }else{
            localStorage.removeItem('access_token');
            localStorage.removeItem('user'); // Always remove stale user data if authentication fails
            return null;
        }

        return response.data; // Return the authenticated user object
    } catch (error) {
        console.error('Authentication check failed:', error);

        localStorage.removeItem('access_token');
        localStorage.removeItem('user'); 
        return null; 
    }
};